<template>
  <div class="dropdown">
    <div
        :id="idToggle"
        class="dropdown-toggle"
        data-bs-toggle="dropdown"
        data-bs-config='{"popperConfig":{"strategy":"fixed"}}'
        aria-expanded="false"
        data-bs-auto-close="outside">
      <el-input
        :size="size"
        :placeholder="placeholder" 
        :id="idSearchAutocomplete"
        v-model="text"
        class="buscador-contactos"
        @input="textChanged"
      >
      <i :id="idIcon" slot="suffix" class="el-input__icon" :class="iconText" @click="clickIcono()"></i>
      </el-input>
    </div>
    <div
      class="dropdown-menu autocomplete-sugerencias mt-1"
      :id="idDropdownMenu"
    >
      <div>
        <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto">
          <slot>
            <p class="infinite-list-item empty text-center">{{ text ? "Sin resultados" : "Escriba para buscar" }}</p>
          </slot>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import searchDebounce from "./searchDebounce";

export default {
  mixins: [searchDebounce],
  props: {
    value:{
      require: true,
      default:()=>{
        return{}
      }
    },
    placeholder:{
      type:String,
      default:()=>""
    },
    size:{
      type:String,
      default:()=>""
    },
    idInput:{
      type:String,
      default:()=>""
    },
  },
  data() {
    return {
      text:"",
      resizeObserver: null,
      localValue:this.value,
      page:0,
      dropdownMenu:{},
      ancho:0,
      iconText:"el-icon-search",
    };
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.onResize);
    let input=document.getElementById(this.idSearchAutocomplete);
    this.resizeObserver.observe(input);
    this.dropdownMenu=document.getElementById(this.idDropdownMenu);
    let icono=document.getElementById(this.idIcon);
    /* icono.addEventListener("mouseenter", (event) => {
      if(Object.entries(this.localValue).length !== 0)
        this.iconText="el-icon-circle-close";
    },false);
    icono.addEventListener('mouseleave', (e) => {
      this.iconText="el-icon-search";
    }); */
  },
  computed: {
    idToggle(){
      return "idToggle"+uuidv4();
    },
    idDropdownMenu(){
      return "dropdown-busqueda"+uuidv4();
    },
    idSearchAutocomplete(){
      return "searchAutocomplete"+uuidv4();
    },
    idIcon(){
      return "icono"+uuidv4();
    }
  },
  methods: {
    onResize() {
      this.ancho=document.getElementById(this.idSearchAutocomplete)?document.getElementById(this.idSearchAutocomplete).offsetWidth:null;
      if(this.ancho)
        this.dropdownMenu.style.width=this.ancho+"px";
    },
    load () {
      if (this.pendingSearchText !== null) return;
      this.page+=1,
      this.$emit("load",this.page,this.text,"scroll");
    },
    textChanged(val){
      this.scheduleSearch(val);
      if(!this.dropdownMenu.classList.contains("show")){
        document.getElementById(this.idToggle).click();
      }
    },
    selected(val,label){
      this.cancelPendingSearch();
      this.localValue=val;
      this.text=label;
    },
    clickToggle(){
      document.getElementById(this.idToggle).click();
    },
    clickIcono(){
      if(this.iconText=="el-icon-circle-close"){
        this.cancelPendingSearch();
        this.text="";
        this.localValue={};
        this.clickToggle();
      }
    }
  },
  watch: {
    value(newVal){
      this.cancelPendingSearch();
      this.localValue=newVal;
      if(Object.entries(this.localValue).length === 0){
        this.text="";
      }
    },
    localValue(newVal){
      this.$emit("input",newVal);
      this.$emit("change",newVal);
    },
  },
};
</script>

<style scoped>
.dropdown-toggle::after{
  content: none;
}
.el-icon-circle-close{
  cursor: pointer;
}
</style>
